import Utils from "../../misc/Utils";
import StoriesModel from "./StoriesModel";

class MobileStoriesView {
    constructor(parent) {
        this.parent = parent;
        this.device = 'mobile';
        this.storyTouchEvent = {
            'start':0,
            'current':0,
            'distance': 0,
            'direction': 'down',
            'initialTransform': 0
        };
    }
    closeStories() {
        let $storiesWrapper = jQuery('.stories-wrapper');
        Utils.hideBodyOverlay();
        this.parent.deactivateStory();
        jQuery(document.body).off('fullscreenchange');
        $storiesWrapper.removeClass('open').hide();
        document.exitFullscreen().catch(() => { /*swallow it*/ });
    }
    openStories(id, response) {
        let $storiesWrapper = jQuery('.stories-wrapper');
        let prepend = (this.parent.model.activeStory.arrayIndex > StoriesModel._stories.indexOf(id));

        Utils.showBodyOverlay();
        $storiesWrapper.addClass('open').show();
        jQuery('.stories-spinner').show();
        $storiesWrapper.find('.stories-wrapper-inner').css('opacity', '0');

        if(typeof response !== 'undefined') {
            let $html = jQuery(response.cargo.html);
            if(prepend) {
                jQuery('.stories-wrapper-inner').prepend($html);
            } else {
                jQuery('.stories-wrapper-inner').append($html);
            }
            $html.find('video').each(function () {
                jQuery(this).storyVideo();
            });
            Utils.initClipboard($html, {container: $storiesWrapper[0]});
        }

        jQuery(document.body).on('fullscreenchange', () => {
            if (!document.fullscreenElement) {
                this.closeStories();
            }
        });

        if ($storiesWrapper[0].requestFullscreen) {
            $storiesWrapper[0].requestFullscreen().finally(() => {
                this.activateOnOpenStory(id);
            });
        } else if ($storiesWrapper[0].webkitRequestFullscreen) { /* Safari */
            $storiesWrapper[0].webkitRequestFullscreen().finally(() => {
                this.activateOnOpenStory(id);
            });
        } else {
            this.activateOnOpenStory(id);
        }
    }
    onFetchStoriesModal(response, prepend){
        if(typeof response !== 'undefined') {
            let $html = jQuery(response.cargo.html);
            if(prepend) {
                jQuery('.stories-wrapper-inner').prepend($html);
            } else {
                jQuery('.stories-wrapper-inner').append($html);
            }
            $html.find('video').each(function () {
                jQuery(this).storyVideo();
            });
            Utils.initClipboard($html, {container: jQuery('.stories-wrapper')[0]});
        }
    }
    onFetchStoriesThumbs(stories, prepend){
        for(let index in stories) {
            if(prepend) {
                this.parent.$thumbWrapper.prepend(this.parent.getStoryThumb(stories[index]));
            } else {
                this.parent.$thumbWrapper.append(this.parent.getStoryThumb(stories[index]));
            }
        }
        if(jQuery('.stories-wrapper.open').length === 0) {
            return;
        }
        let idToFetch = stories[0].id;
        this.parent.model.fetchStoriesModalByIds([idToFetch], (response) => {
            let $storiesWrapper = jQuery('.stories-wrapper');
            if(typeof response !== 'undefined') {
                let $html = jQuery(response.cargo.html);
                if(prepend) {
                    jQuery('.stories-wrapper-inner').prepend($html);
                } else {
                    jQuery('.stories-wrapper-inner').append($html);
                }
                $html.find('video').each(function () {
                    jQuery(this).storyVideo();
                });
                Utils.initClipboard($html, {container: $storiesWrapper[0]});
            }
        });
    }
    activateOnOpenStory(id){
        this.parent.model.activeStory.setId(id);
        this.parent.activateStory();
        if(this.parent.model.activeStory.$el.find('video').length >= 1) {
            this.parent.model.activeStory.$el.find('video').one('loadedmetadata', () => {
                this.scrollToActive();
            });
        } else {
            this.scrollToActive();
        }
    }
    scrollToActive(){
        let $storiesWrapper = jQuery('.stories-wrapper');
        let $wrapper = jQuery('.stories-wrapper-inner');
        let pixels = -this.parent.model.activeStory.$el.position().top;
        $wrapper.css('transition', 'all 0.18s');
        $wrapper.css('transform', 'translateY('+pixels+'px)');
        setTimeout(function () {
            $wrapper.css('transform', 'translateY('+pixels+'px)');
            $wrapper.css('transition', 'none');
            $storiesWrapper.find('.stories-wrapper-inner').css('opacity', '1');
            jQuery('.stories-spinner').hide();
        }, 180);
    }
    shouldRevertTransform() {
        let $activeStory = jQuery('.stories-modal-wrapper.active');

        //if its the first story and the user tries to go upwards
        if($activeStory.index() === 0 && this.storyTouchEvent['direction'] === 'prev'){
            return true;
        }
        //if its the last story and the user tries to go downwards
        if($activeStory.index() === jQuery('.stories-wrapper-inner').children().length - 1 && this.storyTouchEvent['direction'] === 'next') {
            return true;
        }
        //if the user has not scrolled enough in any direction
        if(Math.abs(parseInt(this.storyTouchEvent['distance'])) <= jQuery(window).height() / 20) {
            return true;
        }
        return false;
    }
    onStoryTouchStart(evt) {
        let touch = evt.originalEvent.touches[0] || evt.originalEvent.changedTouches[0];
        this.storyTouchEvent['start'] = touch.pageY;
        this.storyTouchEvent['current'] = touch.pageY;
        this.storyTouchEvent['distance'] = 0;
        this.storyTouchEvent['initialTransform'] = parseInt(jQuery('.stories-wrapper-inner').css('transform').split(',')[5]);
    }
    onStoryTouchMove(evt) {
        let $wrapper = jQuery('.stories-wrapper-inner');
        let touch = evt.originalEvent.touches[0] || evt.originalEvent.changedTouches[0];
        this.storyTouchEvent['distance'] = touch.pageY - this.storyTouchEvent['start'];
        this.storyTouchEvent['direction'] = (touch.pageY > this.storyTouchEvent['current'])?'prev':'next';
        this.storyTouchEvent['current'] = touch.pageY;
        let distance = parseInt(this.storyTouchEvent['distance']);
        let initialTransform = parseInt(this.storyTouchEvent['initialTransform']);
        let targetTransform = initialTransform + distance;
        $wrapper.css('transform', 'translateY('+targetTransform+'px)');
    }
    onSliderScroll(){
        if(this.parent.$sliderInner.scrollLeft() === (this.parent.$sliderInner.prop('scrollWidth') - this.parent.$sliderInner.width())) {
            //right edge
            this.parent.model.fetchStoriesThumbs(false, (stories) => {
                if(typeof stories !== 'undefined') {
                    this.onFetchStoriesThumbs(stories, false);
                }
            });
        } else if(this.parent.$sliderInner.scrollLeft() === 0) {
            //left edge
            this.parent.model.fetchStoriesThumbs(true, (stories) => {
                if(typeof stories !== 'undefined') {
                    this.onFetchStoriesThumbs(stories, true);
                }
            });
        }
    }
}

export default MobileStoriesView;
